export default {
  contact: 'CONTACT',
  signUp: 'SIGN UP',
  signUpText: 'Use this form to stay up to date on the blueprint!',
  sendEmail: '<p>Comments? Feedback?</p><p>Email us at <a href="mailto:blueprint@cnycn.org">blueprint@cnycn.org</a>.</p>',
  firstName: 'First Name',
  lastName: 'Last Name',
  phoneNumber: 'Phone Number',
  email: 'Email Address *required',
  company: 'Company/Organization',
  back: 'TO THE BLUEPRINT SITE'
};
